import {
    SEND_REGISTRATION_SUCCESS,
    SEND_REGISTRATION_AFTER_SUCCESS,
    SEND_REGISTRATION_AFTER_HATCH_SUCCESS
} from './constants';

const registredUser = {};
/**
 *
 * @param state
 * @param action
 * @returns {*}
 */
const registrationReducer = ( state = registredUser, action ) => {

    switch ( action.type ) {
        case SEND_REGISTRATION_SUCCESS:
        case SEND_REGISTRATION_AFTER_SUCCESS:
        case SEND_REGISTRATION_AFTER_HATCH_SUCCESS: {
            return action.user;
        }
        default:
            return state;
    }
};

export { registrationReducer as reguser };
